<section [formGroup]="group()" class="grid gap-8">
  <!-- When the intake was; the member is the one the intervention is for -->
  <div>
    <h2 class="mb-1 text-lg font-semibold text-slate-900">Intake</h2>
    <div class="grid gap-4 md:grid-cols-3">
      <mat-form-field appearance="outline">
        <mat-label>Intake date</mat-label>
        <input matInput [matDatepicker]="intakeDatePicker" formControlName="intakeDate" />
        <mat-datepicker-toggle matIconSuffix [for]="intakeDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #intakeDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Intake time</mat-label>
        <input matInput type="time" formControlName="intakeTime" />
      </mat-form-field>
      <p class="self-center text-sm text-slate-500 md:col-span-3">
        The date and time start at now. The member is the one the intervention is for.
      </p>
    </div>
  </div>

  <!-- The coded problem (cluster and problem, primary and secondary) is recorded on the intervention; it is part of this step -->
  @if (interventionId(); as id) {
    <presenting-problem-panel [interventionId]="id" [interventionStatus]="interventionStatus()" />
  }

  <!-- What the member reports -->
  <div>
    <h2 class="mb-1 text-lg font-semibold text-slate-900">Reason for referral</h2>
    <p class="mb-4 text-sm text-slate-500">The presenting problem as the member reports it.</p>
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Presenting problem description</mat-label>
      <textarea matInput rows="3" formControlName="presentingProblemDescription"></textarea>
    </mat-form-field>
  </div>

  <!-- How long and how bad, side by side, and what came before -->
  <div>
    <h2 class="mb-4 text-lg font-semibold text-slate-900">Details of the presenting problem</h2>
    <div class="grid gap-x-8 gap-y-5 md:grid-cols-2">
      <scale-slider label="Duration" formControlName="presentingProblemDurationId" [options]="options('durationScales')" />
      <scale-slider label="Severity" formControlName="presentingProblemSeverityId" [options]="options('severityScales')" />
    </div>
    <div class="mt-4 grid gap-4 md:grid-cols-2">
      <mat-form-field appearance="outline">
        <mat-label>Previous episodes</mat-label>
        <textarea matInput rows="2" formControlName="previousEpisodes"></textarea>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Previous interventions</mat-label>
        <textarea matInput rows="2" formControlName="previousInterventions"></textarea>
      </mat-form-field>
    </div>
  </div>
</section>
